<div id="get-pro-dialog">
  <button (click)="dialogRef.close(false)" mat-icon-button id="modal-close">
    <mat-icon>close</mat-icon>
  </button>
  <div *ngIf="isLoading; else getPro" class="loading">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>
  <ng-template #getPro>
    <ng-container *ngIf="!hasActiveOrder; else activeOrder">
      <div id="pro-upgrade-content">
        <div class="image">
          <div class="image-text">{{ config.imageText | translate }}</div>
          <img [src]="config.imageUrl" width="365" height="auto" />
        </div>
        <div class="dialog-content">
          <div class="upgrade">
            <mat-chip-listbox class="chips">
              <mat-chip-option class="chip" *ngIf="config.editionName">
                {{ config.editionName | translate }}
              </mat-chip-option>
            </mat-chip-listbox>
            <div *ngIf="config.price !== null">
              {{ config.upgradeNowText | translate }}
            </div>
          </div>
          <div *ngIf="config.price !== null" class="price">
            <span class="amount" [ngClass]="{ small: config.price && config.price.length > 10 }">
              {{ config.price }}
            </span>
            <span
              class="frequency"
              [ngClass]="{
                'small-price': config.price && config.price.length > 10
              }"
            >
              {{ config.frequency | translate }}
            </span>
          </div>
          <div class="selling-points">
            <div class="selling-point" *ngFor="let sellingPoint of config.keySellingPoints">
              <mat-icon>check_circle_outline</mat-icon>
              {{ sellingPoint | translate }}
            </div>
            <div class="selling-point" *ngFor="let sellingPoint of config.templateSellingPoints">
              <ng-container
                *ngIf="!(sellingPoint.template === undefined || sellingPoint.template === null); else noTemplate"
              >
                <mat-icon>check_circle_outline</mat-icon>
                {{ sellingPoint.text | translate : sellingPoint.template }}
              </ng-container>
              <ng-template #noTemplate>
                <mat-icon>check_circle_outline</mat-icon>
                {{ sellingPoint.text | translate }}
              </ng-template>
            </div>
          </div>
          <button mat-raised-button class="upgrade-now-button" color="primary" (click)="dialogRef.close(true)">
            {{ config.ctaText | translate }}
          </button>
        </div>
      </div>
    </ng-container>
    <ng-template #activeOrder>
      <div class="active-order">
        <img class="active-order-image" *ngIf="config.activeOrderImageUrl" [src]="config.activeOrderImageUrl" />
        <span class="active-order-primary">
          {{ config.activeOrderPrimaryText | translate }}
        </span>
        <span class="active-order-secondary">
          {{ config.activeOrderSecondaryText | translate }}
        </span>
      </div>
    </ng-template>
  </ng-template>
</div>
